import BaseObjectDirective from '../BaseObjectDirective';

/**
 * Controller for CMS Preference Select Other Content Object.
 * Extends BaseObjectDirective and handles the logic for selecting other content objects.
 */
class CmsPreferenceSelectOtherContentObjectController extends BaseObjectDirective {
    /**
     * Constructor for CmsPreferenceSelectOtherContentObjectController.
     * @param {Object} $injector - AngularJS injector service.
     * @param {Object} $scope - AngularJS scope.
     * @param {Object} $rootScope - AngularJS root scope.
     * @param {Object} $signals - Signal service for event handling.
     * @param {Object} $interval - AngularJS interval service.
     * @param {Object} ObjectInstanceRegistrationService - Service for object instance registration.
     */
    constructor($injector, $scope, $rootScope, $signals, $interval, ObjectInstanceRegistrationService) {
        super($injector, $scope, $rootScope, $signals, $interval, ObjectInstanceRegistrationService);
        this.$injector = $injector;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$signals = $signals;
        this.$interval = $interval;
        this.ObjectInstanceRegistrationService = ObjectInstanceRegistrationService;

        this.$scope.data = this.$scope.prefData[this.$scope.theKey];
        this.$scope.randomId = angular.createUUID();
        this._taskContext = TaskDataService.fetchContext();

        this.$scope.options = this.getOptions();

        this.onObjectRegistered = this.onObjectRegistered.bind(this);
        this.$signals.on("objectRegistered", this.onObjectRegistered);

        this.$scope.$on('$destroy', () => {
            this.$signals.remove("objectRegistered", this.onObjectRegistered);
        });
    }

    /**
     * Filters selectable objects based on the scope parent and objects.
     * @param {Object} scopeParent - The parent scope.
     * @param {Object} objs - The objects to filter.
     * @returns {Object} - Filtered objects.
     */
    filterSelectObj(scopeParent, objs) {
        let _newObj = {};
        if (!scopeParent) {
            return _newObj;
        }
        for (let key in scopeParent.data.objects) {
            let object = scopeParent.data.objects[key];
            let object_uuid = angular.isUUID(object) ? object : (angular.isUUID(object.uuid) ? object.uuid : false);
            if (object_uuid && objs && objs[object_uuid]) {
                _newObj[object_uuid] = (objs[object_uuid]);
            }
        }
        return _newObj;
    }

    /**
     * Retrieves the options for the select element.
     * @returns {Object} - Options for the select element.
     */
    getOptions() {
        let objs;
        let parents = this._taskContext.getParentsEntryByUUID(this.$scope.parentScope.contentObject.getUUID());
        let containers = _.filter(parents, (item) => {
            return item.getType() === 'container';
        });
        let scopeParent;
        for (let key in containers) {
            let container = containers[key];
            if (container && angular.isFunction(container.getObjects)) {
                if (container.getObjects() && container.getObjects().length && container.getObjects().indexOf(this.$scope.parentScope.contentObject.getUUID()) !== -1) {
                    scopeParent = container;
                }
            }
        }

        if (angular.isDefined(scopeParent)) {
            if (angular.isDefined(this.$scope.data.objectType)) {
                if (this.$scope.data.objectType === 'hint') {
                    objs = FindObjectService.getHintObjectsInContainer(scopeParent);
                    objs = this.filterSelectObj(scopeParent, objs);
                } else {
                    objs = this.ObjectInstanceRegistrationService.getNamedObjectUUIDsByType(this.$scope.data.objectType);
                    objs = this.filterSelectObj(scopeParent, objs);
                }
            } else {
                objs = [];
                console.warn("No objectType passed to cmsPreferenceSelectOtherContentObject", this.$scope);
            }
        }
        return objs;
    }

    /**
     * Handles the event when an object is registered.
     * Updates the options for the select element.
     */
    onObjectRegistered() {
        this.$scope.options = this.getOptions();
        //console.warn("Re-generated options", this.$scope.options);
    }
}

/**
 * Registers the CMS Preference Select Other Content Object directive.
 * @param {Object} module - AngularJS module.
 */
export default function registerCmsPreferenceSelectOtherContentObjectDirective(module) {
    module.directive('cmsPreferenceSelectOtherContentObject', function($compile, $bridges, TaskDataService, FindObjectService) {
        return {
            restrict: 'EA',
            scope: {
                theKey: '=key',
                prefData: '=data',
                parentScope: '=scope'
            },
            templateUrl: "/views/ib/contentobjects/helpers/cms-preference-select-other-content-object.html",
            controller: CmsPreferenceSelectOtherContentObjectController,
            controllerAs: 'ctrl',
            bindToController: true
        };
    });
}